module.exports = "<div class=\"route-content\">\n  Test Component!\n</div>\n"